import { Props } from "./types"

export function Error(props: Props): JSX.Element {
    return (
        <div className="flex h-full w-full">
            <div className="m-auto">{props.message}</div>
        </div>
    )
}
